<template>
  <div class="customer-wrp">
    <div class="title">客户信息</div>
    <div class="first-wrp">
      <FormList
        :list="formList"
        :data="merchantArchivesVo"
        :onChange="onInputChange"
        :onBlur="onBlur"
        :onFocus="onFocus"
      />
      <div class="rollup" v-if="companyListShow">
        <div
          @click="onSelectCompany(item)"
          class="rollup-item"
          v-for="(item, index) in companyList"
          :key="index"
        >
          <div class="rollup-company">
            <div>{{ item.name }}</div>
            <div v-if="item && item.managementBuyerFlag === 1">已添加</div>
          </div>
        </div>
      </div>
    </div>
    <div class="title address-title">
      客户收件地址
      <i class="iconfont" @click="addNewAddress">&#xe61f;</i>
    </div>
    <Address v-for="(item, index) in dataSource" :key="index" :dataSource="item" :editorLink='`/customer/address/edit?id=${item.id}&merchantId=${item.merchantId}`' />

    <ButtonRow
      :firstClick="cancel"
      :secondClick="confirm"
      :bottom="true"
    />
  </div>
</template>

<script>

import { isTaxNo, debounce, subMixStr, removeSpace } from '@utils/basicUtil'
import { customerRequest } from '@services'
import {
  Row,
  Field,
  CellGroup,
  Switch,
  Button,
  Notify
} from 'vant'
import Address from '@components/Address/index.vue'
import FormList from '@components/FormList'
import ButtonRow from '@components/ButtonRow'

export default {
  data () {
    return {
      companyList: [],
      companyListShow: false,
      dataSource: [],

      merchantArchivesVo: {
      },
      loading: false,
      formList: [
        {
          type: 'text',
          field: 'company',
          label: '客户名称',
          placeholder: '请输入客户名称',
          maxlength: '50'
        },
        {
          type: 'text',
          field: 'taxNo',
          placeholder: '请输入客户税号',
          label: '客户税号'
        },
        {
          type: 'text',
          field: 'address',
          placeholder: '请输入地址、电话',
          label: '地址、电话'
        },
        {
          type: 'text',
          field: 'bankName',
          placeholder: '请输入银行、账号',
          label: '银行、账号'
        }
      ]
    }
  },
  mounted () {
    this.getDetail(this.$route.params.id)
  },
  computed: {
  },
  methods: {
    debounce: debounce((vm) => { vm.getSmartTitles() }, 300),
    onSearchTitle (value) {
      if (value.length >= 1) {
        this.debounce(this)
      }
    },
    onBlur ({ e, field }) {
      if (field === 'company') {
        this.testBuyerName(e)
      }
    },
    testBuyerName () {
      if (!this.merchantArchivesVo.company.length) {
        return Notify({ type: 'danger', message: '请填写发票抬头' })
      } else {
        this.merchantArchivesVo.company = subMixStr(this.merchantArchivesVo.company, 100)
      }
    },
    onFocus ({ e, field }) {
      if (field === 'company') {
        this.companyListShow = true
      } else {
        this.companyListShow = false
      }
    },
    onInputChange ({ e, field }) {
      if (field === 'company') {
        this.companyListShow = true
        this.onSearchTitle(e)
      }
      this.merchantArchivesVo[field] = removeSpace(e)
    },
    async getSmartTitles () {
      const data = await customerRequest.smart.smartTitle({ companyName: this.merchantArchivesVo.company })
      if (data.success) {
        this.companyList = data.result
      }
    },
    onSelectCompany (item) {
      this.companyListShow = false
      this.merchantArchivesVo = {
        company: item.name,
        taxNo: item.taxNo,
        address: item.address + item.tel,
        bankName: item.bankName + item.bankNo
      }
    },
    async getDetail (id) {
      const detail = await customerRequest.customer.detail({ merchantId: id })
      if (detail.success) {
        this.merchantArchivesVo = detail.result.merchantArchivesVo
        this.dataSource = detail.result.addresseeInfoResponseList
      }
    },
    cancel () {
      this.$router.go(-1)
    },
    async confirm () {
      if (!isTaxNo(this.merchantArchivesVo.taxNo)) {
        return Notify({ type: 'danger', message: '税号仅支持9/15/18/19/20位大写字母、数字' })
      }
      if (this.merchantArchivesVo.company.trim().length === 0) {
        return Notify({ type: 'danger', message: '客户名称不能为空' })
      }
      if (this.merchantArchivesVo.address.trim().length === 0) {
        return Notify({ type: 'danger', message: '地址信息不能为空' })
      }
      if (this.merchantArchivesVo.bankName.trim().length === 0) {
        return Notify({ type: 'danger', message: '银行信息不能为空' })
      }
      this.loading = true
      const data = await customerRequest.address.addOrEdit({
        merchantArchivesVo: this.merchantArchivesVo
      })
      if (data.success) {
        Notify({ type: 'success', message: '修改成功' })
        this.cancel()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    editAddress () {
      this.$router.push(`/customer/address/edit`)
    },
    addNewAddress () {
      this.$router.push(`/customer/address/add?merchantId=${this.$route.params.id}`)
    }
  },
  components: {
    FormList,
    ButtonRow,
    [Row.name]: Row,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Switch.name]: Switch,
    [Button.name]: Button,
    Address
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
